import * as React from "react";

import { MsalProvider } from "@azure/msal-react";

import Router from "./Router";
import DataProvider from "./DataProvider";
import NotificationProvider from "./NotificationProvider";

import { msalInstance } from "../common/msal";
import { BugsnagErrorBoundary } from "../common/bugsnag";

export default function App() {
  return (
    <BugsnagErrorBoundary>
      <MsalProvider instance={msalInstance}>
        <DataProvider>
          <NotificationProvider>
            <Router />
          </NotificationProvider>
        </DataProvider>
      </MsalProvider>
    </BugsnagErrorBoundary>
  );
}
